/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SystemStatusMessageDTO,
    SystemStatusMessageDTOFromJSON,
    SystemStatusMessageDTOToJSON,
} from '../models';

export interface DeleteSystemStatusMessageRequest {
    messageId: string;
}

export interface GetSystemStatusMessageRequest {
    messageId: string;
}

export interface SaveSystemStatusMessageRequest {
    systemStatusMessageDTO: SystemStatusMessageDTO;
}

/**
 * 
 */
export class SystemStatusMessageApi extends runtime.BaseAPI {

    /**
     */
    async deleteSystemStatusMessageRaw(requestParameters: DeleteSystemStatusMessageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling deleteSystemStatusMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/systemstatusmessage/{messageId}`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteSystemStatusMessage(messageId: string, initOverrides?: RequestInit): Promise<void> {
        await this.deleteSystemStatusMessageRaw({ messageId: messageId }, initOverrides);
    }

    /**
     */
    async getAllSystemStatusMessagesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SystemStatusMessageDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/allsystemstatusmessage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SystemStatusMessageDTOFromJSON));
    }

    /**
     */
    async getAllSystemStatusMessages(initOverrides?: RequestInit): Promise<Array<SystemStatusMessageDTO>> {
        const response = await this.getAllSystemStatusMessagesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCurrentSystemStatusMessageForUserRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SystemStatusMessageDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/systemstatusmessage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SystemStatusMessageDTOFromJSON));
    }

    /**
     */
    async getCurrentSystemStatusMessageForUser(initOverrides?: RequestInit): Promise<Array<SystemStatusMessageDTO>> {
        const response = await this.getCurrentSystemStatusMessageForUserRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getSystemStatusMessageRaw(requestParameters: GetSystemStatusMessageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SystemStatusMessageDTO>> {
        if (requestParameters.messageId === null || requestParameters.messageId === undefined) {
            throw new runtime.RequiredError('messageId','Required parameter requestParameters.messageId was null or undefined when calling getSystemStatusMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/systemstatusmessage/{messageId}`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters.messageId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemStatusMessageDTOFromJSON(jsonValue));
    }

    /**
     */
    async getSystemStatusMessage(messageId: string, initOverrides?: RequestInit): Promise<SystemStatusMessageDTO> {
        const response = await this.getSystemStatusMessageRaw({ messageId: messageId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveSystemStatusMessageRaw(requestParameters: SaveSystemStatusMessageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.systemStatusMessageDTO === null || requestParameters.systemStatusMessageDTO === undefined) {
            throw new runtime.RequiredError('systemStatusMessageDTO','Required parameter requestParameters.systemStatusMessageDTO was null or undefined when calling saveSystemStatusMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/systemstatusmessage`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SystemStatusMessageDTOToJSON(requestParameters.systemStatusMessageDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async saveSystemStatusMessage(systemStatusMessageDTO: SystemStatusMessageDTO, initOverrides?: RequestInit): Promise<void> {
        await this.saveSystemStatusMessageRaw({ systemStatusMessageDTO: systemStatusMessageDTO }, initOverrides);
    }

}
